import { getLang } from '../i18n';
import { getAreaId } from './area';

/** Fehler vom Server mit verständlicher Meldung (409 = jemand anderes hat inzwischen geändert). */
export class ApiFail extends Error {
  constructor(public status: number, message: string) { super(message); }
}

export async function api<T>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', path: string, body?: unknown): Promise<T> {
  let r: Response;
  try {
    r = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: { 'x-lang': getLang(), ...(getAreaId() ? { 'x-area': getAreaId()! } : {}), ...(body !== undefined ? { 'content-type': 'application/json' } : {}) },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiFail(0, getLang() === 'en' ? 'Server unreachable. Please check your connection.' : 'Server nicht erreichbar. Bitte Verbindung prüfen.');
  }
  if (r.status === 401) {
    location.href = `/auth/login?returnTo=${encodeURIComponent(location.pathname + location.search)}`;
    throw new ApiFail(401, getLang() === 'en' ? 'Please sign in again.' : 'Bitte neu anmelden.');
  }
  const json = await r.json().catch(() => ({}));
  if (!r.ok) throw new ApiFail(r.status, (json as { message?: string }).message ?? `Error ${r.status}`);
  return json as T;
}
